module.exports = __webpack_public_path__ + "img/Girl_020024.385ac131.png";